import { useMemo } from 'react';

import type { ToolOptions } from 'bundles/cml/editor/components/toolbars/types';
import { getDefaultTools } from 'bundles/cml/editor/components/toolbars/utils';
import { Tools, type ToolsKeys } from 'bundles/cml/shared/utils/customTools';

type Options = ToolOptions & {
  customTools?: ToolsKeys[];
};

const getFilteredTools = (tools: ToolsKeys[], { enableAiWritingAssistant, enableAutoLayout }: ToolOptions) => {
  return tools.filter((tool: ToolsKeys) => {
    if (tool === Tools.AI && !enableAiWritingAssistant) {
      return false;
    }

    if (tool === Tools.AI_LAYOUT && !enableAutoLayout) {
      return false;
    }

    return true;
  });
};

export const useCustomTools = ({
  monospace,
  pageless,
  isLearnerUpload,
  customTools,
  enableWidgets,
  enableAiWritingAssistant,
  enableAutoLayout,
}: Options) => {
  return useMemo(() => {
    const options: ToolOptions = {
      monospace,
      pageless,
      isLearnerUpload,
      enableWidgets,
      enableAiWritingAssistant,
      enableAutoLayout,
    };

    const tools = getFilteredTools(customTools || getDefaultTools(options), options);

    return { tools, options };
  }, [monospace, pageless, isLearnerUpload, enableWidgets, enableAiWritingAssistant, enableAutoLayout, customTools]);
};
